/**
 * Created by Alphonse-Nearbuy-PC on 5/28/2017.
 */
(function ($) {
    $.fn.ALDayParting = function (options) {
        /** adding class to this **/
        $(this).addClass('ALDayParting');

        /** initializing variables **/

        var self = $(this);
        // This is the easiest way to have default options.
        var matrix = [];

        var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        var daysShortNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ];

        var settings = $.extend(
            {
                // These are the defaults.
            },
            options
        );

        var hours = [
            '12:00 am',
            '01:00 am',
            '02:00 am',
            '03:00 am',
            '04:00 am',
            '05:00 am',
            '06:00 am',
            '07:00 am',
            '08:00 am',
            '09:00 am',
            '10:00 am',
            '11:00 am',
            '12:00 pm',
            '01:00 pm',
            '02:00 pm',
            '03:00 pm',
            '04:00 pm',
            '05:00 pm',
            '06:00 pm',
            '07:00 pm',
            '08:00 pm',
            '09:00 pm',
            '10:00 pm',
            '11:00 pm'
        ];

        /** running the script **/
        var dates = { startDate: settings.startDate, endDate: settings.endDate };
        initialize(dates);

        // for(var i = 0;i<100;i++) {
        //     matrix[Math.floor(Math.random() * 7) + 0][Math.floor(Math.random() * 24) + 0] = 1;
        //     redrawSelections($(this));
        // }

        /** attaching events **/
        var active_selection = false;
        var fromCoors = null;
        var toCoors = null;

        var active_selection_all = false;
        var fromAHour = null;
        var toAHour = null;
        var AapplyValue = null;

        var updatecount = 0;
        var tempMatrix = null;
        $(this).on('mousedown', '.day-hour', function (evt) {
            evt.preventDefault();

            active_selection = true;
            tempMatrix = matrix.map(function (arr) {
                return arr.slice();
            });

            var target_aldp = $(evt.target).attr('data-ALDP');
            var coo = getCoorsForId(target_aldp);
            fromCoors = coo;
            toCoors = coo;
            var applyValue = (matrix[fromCoors[0]][fromCoors[1]] + 1) % 2;
            applyValueInMatrix(tempMatrix, fromCoors, toCoors, applyValue);
        });

        $(this).on('mousedown', '.eday-hour', function (evt) {
            evt.preventDefault();

            active_selection_all = true;
            tempMatrix = matrix.map(function (arr) {
                return arr.slice();
            });
            var target_aldp = $(evt.target).attr('data-ALDP');
            var hour = getAllDayHourFromId(target_aldp);
            fromAHour = hour;
            toAHour = hour;
            var isAllDayAlreadySelected = $(evt.target).hasClass('all-hours-selected');
            var applyValue = 1;
            if (isAllDayAlreadySelected) {
                applyValue = 0;
            }
            AapplyValue = applyValue;
            var fabFromCoo = [0, hour];
            var fabToCoo = [matrix.length - 1, hour];

            applyValueInMatrix(tempMatrix, fabFromCoo, fabToCoo, applyValue);
        });

        $(this).on('mousedown', '.ehour-day', function (evt) {
            evt.preventDefault();

            active_selection_all = true;
            tempMatrix = matrix.map(function (arr) {
                return arr.slice();
            });
            var target_aldp = $(evt.target).attr('data-ALDP');
            var day = getAllHourDayFromId(target_aldp);
            fromAHour = day;
            toAHour = day;
            var isAllDayAlreadySelected = $(evt.target).hasClass('all-days-selected');
            var applyValue = 1;
            if (isAllDayAlreadySelected) {
                applyValue = 0;
            }
            AapplyValue = applyValue;
            var fabFromCoo = [day, 0];
            var fabToCoo = [day, 23];

            applyValueInMatrix(tempMatrix, fabFromCoo, fabToCoo, applyValue);
        });

        $(this).on('mouseup', function (evt) {
            if (active_selection) {
                active_selection = false;
                matrix = tempMatrix.map(function (arr) {
                    return arr.slice();
                });
                fromCoors = null;
                toCoors = null;
                tempMatrix = null;
                redrawSelections(self, matrix);
                redrawSelections(self, matrix);
            }
            if (active_selection_all) {
                active_selection_all = false;
                matrix = tempMatrix.map(function (arr) {
                    return arr.slice();
                });
                fromAHour = null;
                toAHour = null;
                tempMatrix = null;
                AapplyValue = null;
                redrawSelections(self, matrix);
                redrawSelections(self, matrix);
            }
            updatecount++;
            $(self).attr('aldpupdate', updatecount);
            settings.callback();
        });

        $(this).on('mouseenter', '.day-hour', function (evt) {
            if (active_selection) {
                var target_aldp = $(evt.target).attr('data-ALDP');
                var coo = getCoorsForId(target_aldp);
                toCoors = coo;
                var applyValue = (matrix[fromCoors[0]][fromCoors[1]] + 1) % 2;

                tempMatrix = matrix.map(function (arr) {
                    return arr.slice();
                });
                applyValueInMatrix(tempMatrix, fromCoors, toCoors, applyValue);
            }
        });

        $(this).on('mouseenter', '.eday-hour', function (evt) {
            if (active_selection_all) {
                var target_aldp = $(evt.target).attr('data-ALDP');
                var hour = getAllDayHourFromId(target_aldp);
                toAHour = hour;

                var applyValue = AapplyValue;

                var fabFromCoo = [0, hour];
                var fabToCoo = [matrix.length - 1, hour];
                applyValueInMatrix(tempMatrix, fabFromCoo, fabToCoo, applyValue);
            }
        });
        $(this).on('mouseenter', '.ehour-day', function (evt) {
            if (active_selection_all) {
                var target_aldp = $(evt.target).attr('data-ALDP');
                var day = getAllHourDayFromId(target_aldp);
                toADay = day;

                var applyValue = AapplyValue;

                var fabFromCoo = [toADay, 0];
                var fabToCoo = [toADay, 23];
                applyValueInMatrix(tempMatrix, fabFromCoo, fabToCoo, applyValue);
            }
        });
        $(this).on('mouseenter', '.ehour-day', function (evt) {
            if (active_selection_all) {
                var target_aldp = $(evt.target).attr('data-ALDP');
                var day = getAllHourDayFromId(target_aldp);
                toADay = day;

                var applyValue = AapplyValue;

                var fabFromCoo = [toADay, 0];
                var fabToCoo = [toADay, 23];
                applyValueInMatrix(tempMatrix, fabFromCoo, fabToCoo, applyValue);
            }
        });

        $(this).on('mouseleave', function (evt) {
            active_selection = false;
            tempMatrix = null;
            fromCoors = null;
            toCoors = null;

            fromAHour = null;
            toAHour = null;
            active_selection_all = null;
            AapplyValue = null;
            redrawSelections(self, matrix);
            redrawSelections(self, matrix);
        });

        /** functions **/

        function applyValueInMatrix(m, fromC, toC, applyV) {
            var min_x = Math.min(fromC[0], toC[0]);
            var min_y = Math.min(fromC[1], toC[1]);

            var max_x = Math.max(fromC[0], toC[0]);
            var max_y = Math.max(fromC[1], toC[1]);

            for (var ix = min_x; ix <= max_x; ix++) {
                for (var iy = min_y; iy <= max_y; iy++) {
                    m[ix][iy] = applyV;
                }
            }

            redrawSelections(self, m);
            redrawSelections(self, m);
        }

        function initialize(dates, newMatrix) {
            settings.startDate = dates.startDate;
            settings.endDate = dates.endDate;
            if (settings.startDate && settings.endDate) {
                var dates = getDates(settings.startDate, settings.endDate);
                days = [];
                for (var i = 0; i < dates.length; i++) {
                    var d = dates[i],
                        month = '' + d.getMonth(),
                        date = '' + d.getDate(),
                        day = d.getDay(),
                        year = d.getFullYear();
                    // days.push(dates[i].toLocaleString("default", { weekday: "short" }) + " " + dates[i].toISOString().split('T')[0]);
                    days.push(
                        daysShortNames[day] + ' ' + date + ' ' + monthNames[month] + ' ' + year
                    );
                }
                matrix = [];
                for (var i = 0; i < dates.length; i++) {
                    matrix.push([
                        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
                    ]);
                }
            }
            if (settings.days) {
                days = settings.days;
            }

            if (newMatrix) {
                for (var i = 0; i < matrix.length; i++) {
                    for (var j = 0; j < matrix[i].length; j++) {
                        if (newMatrix[i] != undefined && newMatrix[i][j] != undefined) {
                            matrix[i][j] = newMatrix[i][j];
                        }
                    }
                }
            }

            var table = document.createElement('div');
            table.id = settings.id;

            var row = document.createElement('ul');
            row.className =
                'time-set p-0 py-2 border-top border-bottom border-gray-300 d-flex align-items-center';

            // var col = document.createElement('li');
            // col.className = 'time-label d-flex align-items-center montserrat-semi-bold';
            // row.append(col);

            for (var i = 0; i < hours.length; i++) {
                col = document.createElement('li');
                col.className = 'time-label d-flex align-items-center montserrat-semi-bold';
                col.append(hours[i]);
                row.append(col);
            }

            col = document.createElement('li');
            col.append('all');
            col.className = 'montserrat-semi-bold time-label';
            row.append(col);

            table.append(row);

            var scheduleWrapper = document.createElement('div');
            scheduleWrapper.className = 'schedule-table d-flex align-items-start mb-4';

            var timesWrapper = document.createElement('div');
            timesWrapper.className = 'times w-100';

            var usedDays = days;
            for (var i = 0; i < usedDays.length; i++) {
                var row = document.createElement('ul');
                row.className = 'p-0 d-flex align-items-center m-0 row-day row-day-' + i;
                var td = document.createElement('li');
                td.className =
                    'd-block px-2 d-flex align-items-center text-capitalize montserrat-semi-bold ng-star-inserted schedule-label';
                td.append(usedDays[i]);
                row.append(td);

                for (var j = 0; j <= 23; j++) {
                    var td = document.createElement('li');
                    td.className = 'd-inline-block ';
                    var div = document.createElement('div');
                    div.className =
                        'd-block p-0 border border-gray-200 br-4 day-hour ' +
                        'd' +
                        i +
                        '-' +
                        'h' +
                        j;
                    div.setAttribute('data-ALDP', 'd' + i + '-' + 'h' + j);
                    td.append(div);
                    row.append(td);
                }

                // var td =  document.createElement('li');
                // td.className = 'seperator';
                // row.append(td);

                var td = document.createElement('li');
                td.className = 'd-inline-block';
                var div = document.createElement('div');
                div.className =
                    'd-block p-0 border border-gray-200 br-4 ehour-day ' + 'e-' + 'd' + i;
                div.setAttribute('data-ALDP', 'e-' + 'd' + i);
                td.append(div);
                row.append(td);

                timesWrapper.append(row);
            }

            scheduleWrapper.append(timesWrapper);
            table.append(scheduleWrapper);

            // var row = document.createElement('ul');
            // var col = document.createElement('li');
            // col.setAttribute('colspan','25');
            // col.className = 'separator';
            // row.className = 'separator';
            // row.append(col);
            // table.append(row);
            //everyday

            var everyDayWrapper = document.createElement('div');
            everyDayWrapper.className = 'schedule-table every-day d-flex';
            var timesWrapper = document.createElement('div');
            timesWrapper.className = 'times w-100';
            var row = document.createElement('ul');
            row.className = 'p-0 d-flex align-items-center m-0';
            var col = document.createElement('li');
            col.className =
                'd-block px-2 d-flex align-items-center text-capitalize montserrat-semi-bold ng-star-inserted schedule-label';
            col.append('Every Day');
            row.append(col);
            for (var j = 0; j <= 23; j++) {
                var td = document.createElement('li');
                td.className = 'd-inline-block';
                var div = document.createElement('div');
                div.setAttribute('data-ALDP', 'e-' + 'h' + j);
                div.className =
                    'd-block p-0 border border-gray-200 br-4 eday-hour ' + 'e-' + 'h' + j;
                td.append(div);
                row.append(td);
            }

            var td = document.createElement('li');
            td.className = 'd-inline-block';
            var div = document.createElement('div');
            div.className = 'd-block p-0 border border-gray-200 br-4';
            td.append(div);
            row.append(td);

            timesWrapper.append(row);
            everyDayWrapper.append(timesWrapper);
            table.append(everyDayWrapper);
            $('#' + settings.id).remove();
            self.append(table);

            redrawSelections(self, matrix);
            return table;
        }

        function redrawSelections(self, matrixUsed) {
            var dayhours_cells = self.find('.day-hour');
            $.each(dayhours_cells, function (key, value) {
                var dayhouraldp = $(value).attr('data-ALDP');
                var matrixValue = getMatrixValueForId(dayhouraldp, matrixUsed);
                if (matrixValue == 1) {
                    $(value).addClass('day-hour-selected');
                } else {
                    $(value).removeClass('day-hour-selected');
                }
            });

            if (matrixUsed.length > 0) {
                for (var i = 0; i < matrixUsed[0].length; i++) {
                    var allday = true;
                    for (var j = 0; j < matrixUsed.length; j++) {
                        if (matrixUsed[j][i] == 0) {
                            allday = false;
                        }
                    }
                    if (allday) {
                        self.find('.e-h' + i).each(function (k, v) {
                            $(v).addClass('all-hours-selected');
                        });
                    } else {
                        self.find('.e-h' + i).each(function (k, v) {
                            $(v).removeClass('all-hours-selected');
                        });
                    }
                }

                for (var i = 0; i < matrixUsed.length; i++) {
                    var allhours = true;
                    for (var j = 0; j < matrixUsed[0].length; j++) {
                        if (matrixUsed[i][j] == 0) {
                            allhours = false;
                        }
                    }
                    if (allhours) {
                        self.find('.e-d' + i).each(function (k, v) {
                            $(v).addClass('all-days-selected');
                        });
                    } else {
                        self.find('.e-d' + i).each(function (k, v) {
                            $(v).removeClass('all-days-selected');
                        });
                    }
                }
            }
        }

        function getMatrixValueForId(ALPD, matrixx) {
            if (typeof ALPD == 'string') {
                var phase1 = ALPD.replace('d', '').replace('h', '');
                if (phase1.indexOf('-') > -1) {
                    try {
                        var coors = phase1.split('-', 2);
                        return matrixx[parseInt(coors[0])][parseInt(coors[1])];
                    } catch (e) {}
                }
            }
        }

        function getCoorsForId(ALPD) {
            if (typeof ALPD == 'string') {
                var phase1 = ALPD.replace('d', '').replace('h', '');
                if (phase1.indexOf('-') > -1) {
                    var coors = phase1.split('-', 2);
                    return [parseInt(coors[0]), parseInt(coors[1])];
                }
            }
        }

        function getAllDayHourFromId(ALPD) {
            if (typeof ALPD == 'string') {
                var phase1 = ALPD.replace('e-h', '');
                return parseInt(phase1);
            }
        }

        function getAllHourDayFromId(ALPD) {
            if (typeof ALPD == 'string') {
                var phase1 = ALPD.replace('e-d', '');
                return parseInt(phase1);
            }
        }

        function isDateLessThan(d1, d2) {
            return (
                Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate()) <=
                Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate())
            );
        }

        function getDates(start, end) {
            end = new Date(end);
            for (
                var arr = [], dt = new Date(start);
                isDateLessThan(dt, end);
                dt.setDate(dt.getDate() + 1)
            ) {
                arr.push(new Date(dt));
            }
            return arr;
        }

        var returnObj = {
            getMatrixResult: function () {
                return matrix;
            },
            initializeAgain: function (settings, newMatrix) {
                initialize(settings, newMatrix);
            },
            setMatrix: function (matrixNew) {
                if (matrixNew != undefined) {
                    matrix = matrixNew;
                    redrawSelections(self, matrix);
                    redrawSelections(self, matrix);
                }
            }
        };

        return returnObj;
    };
})($);
